<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

  $(function(){
    $(document).on('click','.trigger-parent-add-cart',function(){
      $(this).parents('.product-item').find('.product-form__submit').click();
    })
  })

